import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { Trophy } from 'modules/experiments/components/ui/icons';

import { WinnerBadgeStyle } from './Styled';

export const WinnerTrophyBadge = () => {
  const { t } = useExperimentsTranslations();
  return (
    <WinnerBadgeStyle>
      <Trophy isColorInherited />
      <span>{t('badge.winner')}</span>
    </WinnerBadgeStyle>
  );
};
